import { render, staticRenderFns } from "./selectBomForInheritAndCopy.vue?vue&type=template&id=65f28d94&scoped=true&"
import script from "./selectBomForInheritAndCopy.vue?vue&type=script&lang=js&"
export * from "./selectBomForInheritAndCopy.vue?vue&type=script&lang=js&"
import style0 from "./selectBomForInheritAndCopy.vue?vue&type=style&index=0&id=65f28d94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f28d94",
  null
  
)

export default component.exports